import { Routes, UrlSegment } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('projects/visa-platform/src/app/pages/home/home.component').then(
        (m) => m.HomeComponent
      ),
  },
  {
    matcher: (segments: UrlSegment[]): { consumed: UrlSegment[] } | null => {
      if (
        segments.length >= 2 &&
        segments[0].path === 'external' &&
        segments[1].path === 'sso_login'
      ) {
        return { consumed: segments };
      }
      return null;
    },
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/sso-login/external-sso-login/external-sso-login.component'
      ).then((m) => m.ExternalSSOLoginComponent),
  },
  {
    path: 'sso_login',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/sso-login/sso-login.component'
      ).then((m) => m.SSOLoginComponent),
  },
  {
    path: 'sso_login/failed',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/sso-login/failed/sso-failed.component'
      ).then((m) => m.SSOFailedComponent),
  },
  {
    path: 'offers',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/offer-listing/offer-listing.component'
      ).then((m) => m.OfferListingComponent),
  },
  {
    path: 'airport-cab-booking',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/airport-cab-booking/airport-cab-booking.component'
      ).then((m) => m.AirportCabBookingComponent),
  },
  {
    path: 'airport_transfer/checkout-message/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/booking-confirmation/booking-confirmation.component'
      ).then((m) => m.BookingConfirmationComponent),
  },
  {
    path: 'offer-details/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/offer-details/offer-details.component'
      ).then((m) => m.OfferDetailsComponent),
  },
  {
    path: 'info/terms-and-conditions',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/terms-and-conditions/terms-and-conditions.component'
      ).then((m) => m.TermsAndConditionsComponent),
  },
  {
    path: 'info/privacy-policy',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/privacy-policy/privacy-policy.component'
      ).then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'order-history',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/order-history/order-history.component'
      ).then((m) => m.OrderHistoryComponent),
  },
  {
    path: 'order-history/bookings/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/booking-history-details/booking-history-details.component'
      ).then((m) => m.BookingHistoryDetailsComponent),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
